/**
 * Formats a date string to the custom "X min/hr ago, at Y:YY am/pm on DD MMM YYYY" format.
 * @param {string} dateString - The blog's creation date string (e.g., blog.createdAt).
 * @returns {string} The formatted date string.
 */
export const formatBlogDate = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;

    // --- 1. Calculate the "Time Ago" Part ---
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

    let relativePart = '';

    if (diffMinutes < 60) {
        // Less than 1 hour ago
        relativePart = `${diffMinutes} min ago`;
    } else if (diffHours < 24) {
        // Less than 24 hours ago
        relativePart = `${diffHours} hr ago`;
    } else {
        // More than a day ago, just show the static date (no "time ago" text)
        relativePart = '';
    }

    // --- 2. Format the Static Date Part ---
    
    // a) Get Time (e.g., "2:39 pm")
    const timeOptions = {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true, // Ensures AM/PM format
    };
    // The replace(/\s/g, '') removes any potential extra space from locales that add it.
    const timeStr = new Intl.DateTimeFormat('en-US', timeOptions)
        .format(date)
        .toLowerCase()
        .replace(/\s/g, ' '); 
    // Format is "2:39 pm" or "10:05 am"

    // b) Get Date (e.g., "11 Oct 2025")
    const dateOptions = {
        day: 'numeric',
        month: 'short', // 'Oct'
        year: 'numeric',
    };
    const dateStr = new Intl.DateTimeFormat('en-GB', dateOptions).format(date);
    // Format is "11 Oct 2025"

    // --- 3. Combine the Parts ---

    // The static format requested is: "at 2:39 pm on 11 Oct 2025"
    const staticFormatted = `at ${timeStr} on ${dateStr}`;

    if (relativePart) {
        // If it's less than 24 hours old, combine relative and static parts.
        return `${relativePart}, ${staticFormatted}`;
    } else {
        // If it's more than 24 hours old, just show the precise date/time.
        return staticFormatted.replace('at ', ''); // Remove 'at' for cleaner look on older posts
    }
};